import React from "react";
import { Typography, Box } from "@mui/material";
import { FormDialog, formatDate, preWrap } from "../../Layout/Common";

// Read-only view of one design decision (summary, rationale, alternatives), shared by Human Review and Decisions.
// `decision` null closes it; `children` (e.g. action buttons) render under the text.
export default function DecisionDetailsDialog({ decision: d, onClose, children }) {
    const alts = (d && d.alternatives) || [];
    const decided = d && d.status !== "proposed" && d.decidedDate && new Date(d.decidedDate).getFullYear() > 2000;
    return (
        <FormDialog open={!!d} title={d ? `Decision (${d.kind || "design"}) by ${d.author}` : ""} onClose={onClose} hideConfirm cancelText="Close" maxWidth="md" fullWidth>
            {d && <>
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1 }}>
                    {d.status} · proposed {formatDate(d.createdDate)}{decided ? ` · ${d.status} by ${d.approvedBy || "?"} ${formatDate(d.decidedDate)}` : ""}
                </Typography>
                <Typography variant="subtitle2">Summary</Typography>
                <Typography variant="body2" sx={{ ...preWrap, mb: 1.5 }}>{d.summary}</Typography>
                <Typography variant="subtitle2">Rationale</Typography>
                <Typography variant="body2" sx={{ ...preWrap, mb: 1.5, color: d.rationale ? "text.primary" : "text.secondary" }}>{d.rationale || "(none given)"}</Typography>
                <Typography variant="subtitle2">Alternatives considered</Typography>
                {alts.length
                    ? <Box component="ul" sx={{ mt: 0.5, mb: 1.5, pl: 3 }}>{alts.map((a, i) => <Typography key={i} component="li" variant="body2" sx={preWrap}>{a}</Typography>)}</Box>
                    : <Typography variant="body2" sx={{ color: "text.secondary", mb: 1.5 }}>(none listed)</Typography>}
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>id {d.id}</Typography>
                {children}
            </>}
        </FormDialog>
    );
}
